import { boardTypes } from 'modules/Boards/Types';

export const _defaultBoardTypeDecorator = (obj) => ({
  ...obj,
  type: obj.type ?? boardTypes.personal,
});
